import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import styles from "../../../layout/admin/Main.module.scss";
/*共通コンポーネント*/
import SearchCondition from "../../../features/SearchCondition";
import TextField from "../../../ui/TextField";
import RangeField from "../../../ui/RangeField";
import CheckboxGroup from "../../../ui/CheckboxGroup";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
/*API */
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
/*バリデーション */
import { validateMaxlength } from "../../../../utils/validate";

const codeIsControl = "CD007";
const codePublishedTo = "CD008";
const codeLotteryStatus = "CD003";

const SearchForm = ({ setSearchCondition, authority }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  //チェックボックス選択肢
  const [isControleElements, setIsControleElements] = useState([]); //公開フラグ
  const [publishedToElements, setPublishedToElements] = useState([]); //公開先
  const [lotteryStatusElements, setLotteryStatusElements] = useState([]); //抽選ステータス

  //初回レンダリング
  useEffect(() => {
    const mapCodeFunc = (d) => {
      return {
        label: d.d_text,
        value: d.d_value,
      };
    };

    (async function () {
      //区分値チェックボックスセット
      //公開フラグ
      const icData = await getCodeMasterList({ code: codeIsControl });
      setIsControleElements(icData.map(mapCodeFunc));
      //公開先
      const puData = await getCodeMasterList({ code: codePublishedTo });
      setPublishedToElements(puData.map(mapCodeFunc));
      //抽選ステータス
      const ltData = await getCodeMasterList({ code: codeLotteryStatus });
      setLotteryStatusElements(ltData.map(mapCodeFunc));
    })();
  }, []); //初回レンダリング

  //検索条件リセット
  const resetCondition = () => {
    setValue("title", "");
    setValue("created_at", "");
    setValue("period_to_s", "");
    setValue("period_to_e", "");
    setValue("generation_id", "");
    setValue("course_id", "");
    //TODO チェックボックス値セット 時間があれば整備
    setValue("is_control_0", false);
    setValue("is_control_1", false);
    setValue("published_to_1", false);
    setValue("published_to_2", false);
    setValue("published_to_3", false);
    setValue("lottery_status_1", false);
    setValue("lottery_status_2", false);
    setValue("lottery_status_3", false);
    setValue("lottery_status_4", false);
  };

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="お知らせを絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(100) }}
                  name="title"
                  errors={errors}
                  label="件名"
                  placeholder="件名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  type="date"
                  register={register}
                  name="created_at"
                  errors={errors}
                  label="日付"
                ></TextField>
              </tr>
              <tr>
                <RangeField
                  type="date"
                  register={register}
                  nameFrom={"period_to_s"}
                  nameTo={"period_to_e"}
                  errors={errors}
                  label="掲載期間(To)"
                ></RangeField>
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="公開"
                  name="is_control"
                  elements={isControleElements}
                />
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="公開先"
                  name="published_to"
                  elements={publishedToElements}
                />
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(4) }}
                  name="generation_id"
                  errors={errors}
                  label="期生ID"
                  placeholder="期生ID"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{ ...validateMaxlength(10) }}
                  name="course_id"
                  errors={errors}
                  label="講座ID"
                  placeholder="講座ID"
                ></TextField>
              </tr>
              <tr>
                <CheckboxGroup
                  errors={errors}
                  register={register}
                  label="当選状況"
                  name="lottery_status"
                  elements={lotteryStatusElements}
                />
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default SearchForm;
